import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServices from "../../../services/RequestServies";
import Swal from "sweetalert2";
import TransferTable from "./TransferTable";
import MIVTable from "./MIVTable";
import RVTable from "./RVTable";

const Casting = () => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [data, setData] = useState({});
  const [displayRequestType, setDisplayRequestType] = useState("miv"); // Controls table rendering

  // Store search parameters separately
  const [searchParams, setSearchParams] = useState({
    formNumber: "",
    requestType: "miv",
    selectedStore: "",
  });

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  useEffect(() => {
    setSearchParams((prev) => ({ ...prev, selectedStore: defaultStore }));
  }, [defaultStore]);

  const handleSearch = async () => {
    if (!searchParams.formNumber) {
      Swal.fire("Error", "Please enter form number and select a store", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await RequestServices.getdocumetwithitems({
        no: searchParams.formNumber,
        type: searchParams.requestType,
        store: searchParams.selectedStore,
      });

      setData(res);
      setReportData(res?.document?.items || []);
      setDisplayRequestType(searchParams.requestType); // Update table type only after search
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-xl-12">
      {/* Filter Section */}
      <div className="filter cm-content-box box-primary">
        <div className="content-title">
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link to={"#"} className={`SlideToolHeader ${open ? "collapse" : "expand"}`} onClick={() => setOpen(!open)}>
              <i className={`fas ${open ? "fa-angle-down" : "fa-angle-up"}`}></i>
            </Link>
          </div>
        </div>

        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Enter Form Number</label>
                  <input
                    type="text"
                    placeholder="Enter Form Number"
                    className="form-control mb-xxl-0 mb-3"
                    value={searchParams.formNumber}
                    onChange={(e) => setSearchParams({ ...searchParams, formNumber: e.target.value })}
                  />
                </div>

                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Select Request Type</label>
                  <select
                    className="form-select"
                    style={{ height: "55px" }}
                    value={searchParams.requestType}
                    onChange={(e) => setSearchParams({ ...searchParams, requestType: e.target.value })}
                  >
                    {/* Temporarily hidden - uncomment below line to show Requisition Voucher again */}
                    {/* <option value="rv">Requisition Voucher</option> */}

                    <option value="miv">Material Issue Voucher (MIV)</option>
                  </select>
                </div>

                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Store</label>
                  <select
                    className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                    value={searchParams.selectedStore}
                    onChange={(e) => setSearchParams({ ...searchParams, selectedStore: e.target.value })}
                  >
                    {availableStores.map((store) => (
                      <option key={store._id} value={store._id}>
                        {`${store.name}, ${store.location}`}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-xl-3 col-xxl-3">
                  <label className="ms-2">Search</label>
                  <button className="form-control btn btn-primary" onClick={handleSearch} disabled={loading}>
                    {loading ? "Loading..." : "Search"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      {/* Dynamic Table Rendering */}
      {displayRequestType === "transfer" && (
        <TransferTable data={data} reportData={reportData} totalcount={reportData.length} />
      )}
      {displayRequestType === "rv" && (
        <RVTable reportData={reportData} totalcount={reportData.length} data={data} loginUser={user} />
      )}
      {displayRequestType === "miv" && (
        <MIVTable data={data} reportData={reportData} totalcount={reportData.length} loginUser={user} />
      )}
    </div>
  );
};

export default Casting;
